/**
 * Created by User on 1/12/2017.
 */
import {ResponseMessage} from "../response_message";
import {MessageTypes} from "../message_types";
import {deserializeArrayOfObject} from "../json_deserialization/json_deserialization";
import {CountryMessageData} from "../message_data/country_message_data";


export class CountriesByBrandResponseMessage extends ResponseMessage {
    countries: Array<CountryMessageData>;

    constructor() {
        super()
        this.type = MessageTypes.CountriesByBrandResponse;
    }

    deserialize(jsonObject: any): void {
        super.deserialize(jsonObject);
        this.countries = deserializeArrayOfObject(jsonObject.countries, CountryMessageData);
    }
}
